import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async loginUser(data) {
    let response = await apiCall("login", data);
    return response;
  },
  async ActivateAccount(data) {
    let response = await apiCall("user/account/activate", data);
    return response;
  },
  async UserForgotPassword(data) {
    let response = await apiCall("login", data);
    return response;
  },
  async fetchStationUserList(data) {
    let response = await apiCall("user/list", data);
    return response;
  },
  async fetchCompanyUserList(data) {
    let response = await apiCall("user/list/company_user", data);
    return response;
  },
  async getUserPermissionCodes(data) {
    let response = await apiCall("user/permission/codes", data);
    return response;
  },
  async getUserPermissionCodess(data) {
    let response = await apiCall("user/permission/codess", data);
    return response;
  },
  async createUser(data) {
    let response = await apiCall("user/create", data);
    return response;
  },
  async getUsersMinimal_data(data) {
    let response = await apiCall("user/list_users_min_data", data);
    return response;
  },
  async updateUser(
    user_id,
    first_name,
    last_name,
    username,
    email,
    nin,
    district,
    role_id,
    contact
  ) {
    let data = {
      user_id: user_id,
      first_name: first_name,
      last_name: last_name,
      username: username,
      email: email,
      nin: nin,
      district: district,
      role_id: role_id,
      contact: contact,
    };
    let response = await apiCall("user/update", data);
    return response;
  },
  async updateUserProfile(data) {
    let response = await apiCall("user/profile/update", data);
    return response;
  },
  async updatePassword(data) {
    let response = await apiCall("password/update", data);
    return response;
  },
  async getUserList(data) {
    let response = await apiCall("user/list", data);
    return response;
  },
  async fetchUserNumber(data) {
    let response = await apiCall("user/count", data);
    return response;
  },
  async fetchSingleUser(data) {
    let response = await apiCall("user/list/single", data);
    return response;
  },
  async searchUsers(search) {
    let data = {
      search: search,
    };
    let response = await apiCall("user/search", data);
    return response;
  },
  async updatePasswordByAdmin(user_id) {
    let data = {
      user_id: user_id,
    };
    let response = await apiCall("password/update/admin", data);
    return response;
  },
  async disableUser(user_id) {
    let data = {
      user_id: user_id,
    };
    let response = await apiCall("user/disable", data);
    return response;
  },
  async enableUser(user_id) {
    let data = {
      user_id: user_id,
    };
    let response = await apiCall("user/enable", data);
    return response;
  },
};
